// extracted by mini-css-extract-plugin
export default {"fe":"style_fe__oWlC-"};